import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'formatCamelCase'
})
export class FormatCamelCasePipe implements PipeTransform {
	transform(value: string | null | undefined): string {
		if (!value) {
			return '';
		}
		return value.replace(/([a-z])([A-Z])/g, '$1 $2');
	}
}

